import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Footer() {
  return (
    <footer className="bg-secondary-950 text-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="inline-block mb-4">
              <span className="text-xl font-bold font-heading text-background-50 whitespace-nowrap">尾巴漫画</span>
            </Link>
            <p className="text-sm text-foreground-300 leading-relaxed">
              尾巴漫画汇聚精选无删减韩国漫画，提供下拉式免费韩漫在线阅读。热门韩漫实时跟进，为您带来舒适的阅读体验。
            </p>
            <div className="flex items-center gap-3 mt-4">
              <a href="#" className="flex items-center justify-center w-8 h-8 rounded-full bg-secondary-800 hover:bg-primary-500 transition-colors duration-200" aria-label="微博">
                <i className="ri-weibo-line text-sm w-4 h-4 flex items-center justify-center"></i>
              </a>
              <a href="#" className="flex items-center justify-center w-8 h-8 rounded-full bg-secondary-800 hover:bg-primary-500 transition-colors duration-200" aria-label="微信">
                <i className="ri-wechat-line text-sm w-4 h-4 flex items-center justify-center"></i>
              </a>
              <a href="#" className="flex items-center justify-center w-8 h-8 rounded-full bg-secondary-800 hover:bg-primary-500 transition-colors duration-200" aria-label="QQ">
                <i className="ri-qq-line text-sm w-4 h-4 flex items-center justify-center"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 whitespace-nowrap">分类导航</h4>
            <ul className="space-y-2.5">
              {categories.filter((c) => c.slug !== 'all').slice(0, 6).map((cat) => (
                <li key={cat.slug}>
                  <Link to={`/category/${cat.slug}`} className="text-sm text-foreground-300 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 whitespace-nowrap">快速链接</h4>
            <ul className="space-y-2.5">
              <li><Link to="/" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">首页</Link></li>
              <li><Link to="/category/all" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">全部漫画</Link></li>
              <li><Link to="/about" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">关于我们</Link></li>
              <li><a href="#" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">用户协议</a></li>
              <li><a href="#" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">隐私政策</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 whitespace-nowrap">联系我们</h4>
            <ul className="space-y-2.5">
              <li className="flex items-start gap-2">
                <i className="ri-mail-line text-sm text-foreground-300 w-4 h-4 flex items-center justify-center mt-0.5"></i>
                <span className="text-sm text-foreground-300">contact@weibamanga.com</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-customer-service-2-line text-sm text-foreground-300 w-4 h-4 flex items-center justify-center mt-0.5"></i>
                <span className="text-sm text-foreground-300">在线客服：工作日 9:00-18:00</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line text-sm text-foreground-300 w-4 h-4 flex items-center justify-center mt-0.5"></i>
                <span className="text-sm text-foreground-300">北京市朝阳区望京SOHO</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-secondary-800 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-400">
            &copy; {new Date().getFullYear()} 尾巴漫画 weibamanga.com - 韩国漫画无删减漫画下拉式免费韩漫大全
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-400 hover:text-foreground-300 transition-colors duration-200 whitespace-nowrap" rel="nofollow">用户协议</a>
            <a href="#" className="text-xs text-foreground-400 hover:text-foreground-300 transition-colors duration-200 whitespace-nowrap" rel="nofollow">隐私政策</a>
            <a href="#" className="text-xs text-foreground-400 hover:text-foreground-300 transition-colors duration-200 whitespace-nowrap" rel="nofollow">版权声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}